export default __webpack_public_path__ + "static/media/956.ec9dddfa.gif";